import { colors } from '@alixpartners/ui-components';

import styled from 'styled-components';

const large = 1800;
const xl = 2400;

export const ReportLandingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: calc(100vh - 48px);
  width: 100%;
  padding: 64px;
  background-image: url(/img/landing_bg.jpg);
  background-size: cover;
  box-sizing: border-box;
`;

export const CentralContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  text-align: center;
  @media (min-width: ${large}px) {
    max-width: 600px;
  }
  @media (min-width: ${xl}px) {
    min-width: 900px;
  }
`;

export const Header = styled.h1`
  font-weight: 700;
  margin: 0 0 32px 0;
  padding: 0;
  font-size: 48px;
  line-height: 58px;
  color: ${colors.black};
  @media (min-width: ${large}px) {
    font-size: 64px;
    line-height: 74px;
  }
  @media (min-width: ${xl}px) {
    font-size: 80px;
    line-height: 90px;
  }
`;

export const ReportLandingText = styled.p`
  margin: 0 0 32px 0;
  padding: 0;
  font-size: 23px;
  line-height: 28px;
  color: ${colors.grey700};
  text-align: left;
  @media (min-width: ${large}px) {
    font-size: 32px;
    line-height: 38px;
  }
  @media (min-width: ${xl}px) {
    font-size: 38px;
    line-height: 44px;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 600px;
  height: 32px;
  text-align: center;
  margin-top: 16px;
  position: absolute;
  bottom: 64px;
  left: 64px;
`;
